<template>
  <div class="tooltip">
    <img src="../assets/ui/info.svg" alt="">
    <span class="tooltip__text">
      <slot></slot>
    </span>
  </div>
</template>

<script>

export default {
  name: 'Watch',
}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip__text {
  visibility: hidden;
  background-color: white;
  color: var(--green--dark);
  text-align: center;
  padding: 25px;
  border-radius: 6px;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + 30px);
  width: 300px;
  z-index: 1;
}

.tooltip__text::before {
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid white;
  position: absolute;
  bottom: -19px;
  left: 50%;
  transform: translateX(-50%);
}

@media only screen and (max-width: 1000px) {
  .tooltip__text {
    right: -19px;
    left: unset;
    transform: unset;
  }

  .tooltip__text::before {
    right: 10px;
    left: unset;
    transform: unset;
  }
}

.tooltip:hover .tooltip__text {
  visibility: visible;
}
</style>
